export enum BRANDS {
  BK = 'BK',
  PLK = 'PLK',
  TH = 'TH',
}
